import { NgModule } from '@angular/core';
import { CreateEventService } from './shared/createevent.listener';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule, MatExpansionModule, NgSelectModule, CommonModule],
    exports: [
        MatExpansionModule
    ],
    providers: [CreateEventService],
})
export class NavModule { }
